export const productToursFeatures = {
    summary: {
        name: 'Product Tours',
        description: 'Communicate with users through product tours, tooltips, and popups',
        // url: '/cdp',
        // docsUrl: '/docs/cdp',
    },
    features: {},
}
